<div class="row" style="height:85%;">
    <div class="col-lg-12">
        <div class="box-header page-header with-border">

            <!-- =================================== TITLE (START)==================================== -->
            <!-- <h3 class="box-title"
                style="font-family: 'Inconsolata', monospace;font-weight: bold;color: #3c8dbc; margin-left: 10px;"><i
                    class="fa fa-list"></i>

                <span style="text-decoration: underline">

                    <span>Liste des locations du véhicule :</span>
                    <a style="color: black; text-decoration-color: #3c8dbc;" title="Afficher la véhicule"
                        [routerLink]="['/client/dataManagement/vehicule/form', selectedVehicule.idVehicule, 'SHOW']">{{selectedVehicule.matricule}}</a>

                    <span *ngIf="selectedVehicule.driver"> - conducteur :
                        <a style="color: black; text-decoration-color: #3c8dbc;" title="Afficher le conducteur"
                            [routerLink]="['/client/dataManagement/driver/form', selectedVehicule.driver.idDriver, 'SHOW']">{{selectedVehicule?.driver?.firstName}}
                            {{selectedVehicule?.driver?.lastName}}</a>
                    </span>

                </span>


                <span *ngIf="!selectedVehicule.driver" data-toggle="tooltip" class="badge label-warning">
                    <i class="fa fa-info" aria-hidden="true"></i> Aucun conducteur trouvé !
                </span>

            </h3> -->
            <!-- =================================== TITLE (END)==================================== -->

            <!-- =================================== OPTIONS (START)==================================== -->
            <div class="option-add">

                <button type="button" class="btn btn-success btn-sm " title="Ajouter"
                    (click)="openAddDocumentModal()"><i class="fa fa-plus-circle"></i> </button>

            </div>
            <div *ngIf="leasingsId.length > 0" class="option-delete">
                <span title="Supprimer tout" (click)="onConfirmDeleteMultiple()">
                    <i class="fa fa-minus-circle"></i> Supprimer tout</span>
            </div>
            <!-- =================================== OPTIONS (END)==================================== -->
            <!--==================================== import/Export functionality(START)=============== -->
            <div style="display: inline-block; margin-left: 5px;">
                <div class="option-export">

                    <button type="button" class="btn btn-primary btn-sm  " title="Exporter sous format excel"
                        (click)='export()'>Exporter <i class="fa fa-download"></i> </button>

                </div>
            </div>
            <!--==================================== import/Export functionality(END)================= -->
            <!--==================================== Search(START)=============== -->
            <div class="pull-right">
                <div class="inputWithIcon">
                    <input [(ngModel)]="searchTerm" name="searchTerm" type="text" class="form-control input-sm"
                        placeholder="Fournisseur...">
                    <i class="fa fa-search" aria-hidden="true"></i>
                </div>
            </div>
            <!--==================================== Search(END)================= -->
        </div>
    </div>
    <div class="col-lg-12">
        <!-- ========================================== LIST SINISTRES (START) ====================================================-->
        <div class="content">
            <div class="table-responsive tableFixHead">
                <table class="table table-striped table-hover table-condensed">
                    <thead>
                        <tr>
                            <th style="width: 2%; text-align: left;"><input type="checkbox"
                                    [disabled]="leasings.length == 0" [checked]="leasings.length == leasingsId.length"
                                    (click)="onCheckedAll()"></th>
                            <th style="width:5%">Début Echéance</th>
                            <th style="width:5%">Fin Echéance</th>
                            <th style="width:5%">Fournisseur</th>
                            <th style="width:5%">Type</th>
                            <th style="width:5%">Montant Crédit
                                <!--<span style="background-color: white; color: #3c8dbc">
                                    (total : {{maturityAmountTotal()}} DH)
                                </span>-->
                            </th>
                            <th style="width:5%">Montant Echéance
                                <span style="background-color: white; color: #3c8dbc">
                                    (total : {{costTotal() | number: '.0-4'}} DH)
                                </span>
                            </th>
                            <th style="width: 45%" style="border-left-style:none;"></th>
                            <th style="width:5%"></th>
                        </tr>
                    </thead>

                    <tbody>

                        <tr *ngIf="loading">
                            <td colspan="8" style="text-align: center">
                                <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                            </td>
                        </tr>

                        <tr *ngIf="!loading && leasings.length == 0">
                            <td colspan="8">
                                <div class="alert alert-dismissible"
                                    style="border-radius: 0px;text-align: center;">
                                    <button type="button" class="close" data-dismiss="alert" aria-hidden="true">
                                        ×
                                    </button>
                                    <h4 style="color: orange">
                                        <i class="fa fa-info-circle"></i> Information
                                    </h4>
                                    Veuillez ajouter des informations pour locations.
                                </div>
                            </td>
                        </tr>


                        <tr *ngFor="let document of getLeasings()">
                            <td>
                                <input type="checkbox" [checked]="isCheckedInList(document.id)"
                                    (click)="onChecked(document.id)">
                            </td>
                            <td style="font-weight: bold">
                                {{document?.operationTime | date: 'dd-MM-yyyy'}}
                            </td>
                            <td style="font-weight: bold">
                                {{document?.endTime | date: 'dd-MM-yyyy'}}
                            </td>
                            <td>
                                {{document?.provider?.name}}
                            </td>
                            <td>
                                {{document?.place}}
                            </td>
                            <td>
                                {{document?.maturityAmount}}
                                <span class="label label-info">
                                    ({{document?.maturityAmount / maturityAmountTotal() * 100 |number:'.2-3'}} %)
                                </span>
                            </td>
                            <td>
                                {{document?.cost}}
                                <span class="label label-info">
                                    ({{document?.cost / costTotal() * 100 |number:'.2-3'}} %)
                                </span>
                            </td>
                            <td></td>
                            <td>

                                <button title="Supprimer" style="color: red;" (click)="onConfirmDelete(document)"
                                    type="button" class="btn btn-sm btn-default">
                                    <i class="fa fa-trash-o" aria-hidden="true"></i>
                                </button>
                                <button title="Modifier" style="color: rgb(2, 157, 196); " type="button"
                                    class="btn btn-sm btn-default" (click)="updateDocmuent(document)">
                                    <i class="fa fa-edit" aria-hidden="true"></i>
                                </button>

                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>

        </div>
        <!-- ========================================== LIST SINISTRES (END) ====================================================-->
    </div>

</div>


<!-- ========================================== ADD/Edit Modal (START) ====================================================-->
<div class="modal fade" bsModal #addEditModal="bs-modal" role="dialog">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- ========================== Modal TITLE (START) ===============================-->
            <div class="modal-header">

                <button type="button" class="close" (click)="addEditModal.hide()">&times;</button>

                <h4 *ngIf="mode == 'ADD'" class="modal-title"
                    style="font-family: 'Inconsolata', monospace;font-weight: bold;color: #3c8dbc;">
                    <i class="fa fa-plus"></i>
                    Ajouter informations location
                </h4>

                <h4 *ngIf="mode == 'UPDATE'" class="modal-title"
                    style="font-family: 'Inconsolata', monospace;font-weight: bold;color: #3c8dbc;">
                    <i class="fa fa-edit"></i>
                    Modifier informations location
                </h4>
            </div>
            <!-- ========================== Modal TITLE (END) ===============================-->

            <div class="modal-body">
                <form #batteryForm="ngForm" class="form-horizontal">
                    <div class="box-body">
                        <app-document-form [document]="selectedLeasing" [mode]="mode" [vehicule]="selectedVehicule"
                            [group]="selectedGroup" (documentWasAdded)="documentWasAdded($event)"
                            (documentWasUpdated)="documentWasUpdated($event)" (cancelOperation)="addEditModal.hide()">
                        </app-document-form>
                    </div>
                </form>
            </div>

        </div>

    </div>
</div>
<!-- ========================================== ADD/Edit Modal (END) ====================================================-->
<!-- ============================== DELETE MODAL (START) ========================== -->
<div class="modal fade" bsModal #leasingDeleteModal="bs-modal" role="dialog">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="leasingDeleteModal.hide()">&times;</button>
                <h4 class="modal-title">
                    <i class="fa fa-cogs" aria-hidden="true"></i> Êtes-vous sûr ?
                </h4>
            </div>
            <div class="modal-body">
                <div class="alert alert-danger alert-dismissible" style="border-radius: 0px;text-align: center">
                    <h4 style="color: white">
                        <i class="fa fa-exclamation-triangle"></i> Attention !
                    </h4>
                    <span *ngIf="!isDeleteMultiple">Êtes-vous sûr de supprimer ce location ?</span>
                    <span *ngIf="isDeleteMultiple">Êtes-vous sûr de supprimer ces {{leasingsId.length}}
                        locations
                        ?</span>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="leasingDeleteModal.hide()">
                    Annuler
                </button>
                <button type="button" class="btn btn-success" (click)="onDelete()">
                    <i class="fa fa-check" aria-hidden="true" *ngIf="!loading"></i>
                    <i class="fa fa-spinner fa-spin" *ngIf="loading"></i> Oui, Je confirme
                </button>
            </div>
        </div>
    </div>
</div>
<!-- =============================== DELETE MODAL (END) ============================= -->
<!--=================================Import leasing (start) ====================================-->
<div class="modal" role="dialog" bsModal #importModal="bs-modal">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" (click)="importModal.hide()">&times;
                </button>
                <h4 class="modal-title">
                    <i class="fa fa-cogs" aria-hidden="true"></i> Importer la liste des locations
                </h4>
            </div>
            <div class="modal-body vertical-spacer">
                <app-import-export-forms [item]='selectedItem' [vehiculeMatricule]='selectedVehicule.matricule'
                    [groupId]="selectedGroup.idGroupe" (importedItem)='itemWasImported($event)'>
                </app-import-export-forms>
            </div>
            <p></p>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="importModal.hide()">
                    Fermer
                </button>
            </div>
        </div>
    </div>
</div>
<!--=================================Import leasing (end) ====================================-->
